import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardBuyCreditPacksRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardBuyCreditPacksContainerLoadable } from './OrgDashboardBuyCreditPacksContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardBuyCreditPacksRoute>,
) {
  await OrgDashboardBuyCreditPacksContainerLoadable.load();
}

export default function OrgDashboardBuyCreditPacksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardBuyCreditPacksContainerLoadable />;
}
